import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "company" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "label ellipsis" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "content machine-list" }
const _hoisted_6 = { class: "footer" }

import { ref, computed } from 'vue'
import { CompanyFacilityDto, FacilityDto } from '@/api/attendance'
import MachineCard from '@/views/attendance/components/machine-card.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'company-card',
  props: {
    data: { default: () => ({}) }
  },
  emits: ["createMachine", "editMachine", "detailMachine", "removeMachine"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const expand = ref(false)

const displayList = computed(() => {
    return expand.value ? props.data.facilityList : props.data.facilityList.slice(0, 1)
})

const onEditMachine = (machine: FacilityDto) => {
    emits('editMachine', {
        ...machine,
        serveCompanyId: machine.serveCompanyId || props.data.serveCompanyId,
        serveCompanyName: machine.serveCompanyName || props.data.serveCompanyName
    })
}

const onDetailMachine = (machine: FacilityDto) => {
    emits('detailMachine', {
        ...machine,
        serveCompanyId: machine.serveCompanyId || props.data.serveCompanyId,
        serveCompanyName: machine.serveCompanyName || props.data.serveCompanyName
    })
}

const onRemoveMachine = (machine: FacilityDto) => {
    emits('removeMachine', {
        ...machine,
        serveCompanyId: machine.serveCompanyId || props.data.serveCompanyId,
        serveCompanyName: machine.serveCompanyName || props.data.serveCompanyName
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon" }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.serveCompanyName), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.facilityCount || 0) + "台", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList.value, (item) => {
        return (_openBlock(), _createBlock(MachineCard, {
          key: item.id,
          data: item,
          onEditMachine: onEditMachine,
          onDetailMachine: onDetailMachine,
          onRemoveMachine: onRemoveMachine
        }, null, 8, ["data"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "create",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('createMachine', _ctx.data)))
      }, [
        _createVNode(_component_el_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon-plus" }),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "当前企业添加考勤机", -1))
          ]),
          _: 1
        })
      ]),
      (_ctx.data.facilityList?.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "create",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (expand.value = !expand.value))
          }, [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: _normalizeClass(expand.value ? 'el-icon-arrow-up' : 'el-icon-arrow-down')
                }, null, 8, ["class"]),
                _createElementVNode("span", null, _toDisplayString(expand.value ? '收起' : '展开'), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})